// Disable Scroll
window.disableScroll = function () {
  const body = document.querySelector('body');
  const cHeight = document.querySelector('#site-wrapper').offsetHeight;

  body.style.height = `${cHeight}px`;
  body.style.top = `0px`;
  body.classList.add('disable-scroll');
}
